import type { OutFoto } from '@/core/db/entities'
import type { PhotoHandle } from './photoStorage'

/**
 * Reconstrói o `PhotoHandle` a partir do registro persistido em `out_foto`.
 *
 * Lógica:
 *  - Se tem `localPath`: kind='path' (registro foi salvo via FilesystemPhotoStorage)
 *  - Se tem `fileBlob`: kind='blob' (registro foi salvo via BlobPhotoStorage)
 *  - Senão: registro corrompido — fileBlob foi evictado pelo Safari e localPath
 *    nunca foi setado. Caller decide o que fazer (geralmente: signed URL do
 *    backend pra fotos já SYNCED).
 *
 * Retorna `null` quando ambos faltam.
 */
export function handleFromFoto(foto: OutFoto): PhotoHandle | null {
  if (foto.localPath) {
    return {
      kind: 'path',
      path: foto.localPath,
      mime: foto.mime,
      size: foto.sizeBytes,
    }
  }
  if (foto.fileBlob) {
    return { kind: 'blob', blob: foto.fileBlob }
  }
  return null
}
